module.exports = __webpack_public_path__ + "static/media/quantity.9fc1efc2.png";